<template>
    <div class="weChat_pay_pages">
        <router-view v-wechat-title='$route.meta.title'></router-view>
        <div class="countdown flex2">
            <img src="@/images/timers.png" class="timers">
            <div class="countdown_text">请尽快完成支付，还剩{{min}}分{{second}}秒</div>
        </div>
        <div class="pay_text">支付金额</div>
        <div class="flex2 pay_num">
            <div class="symbol">￥</div>
            <div class="num">10.00</div>
        </div>
        <div class="tip">
            <div class="tip1">支付后等待医生发起视频诊疗</div>
            <div class="tip2">如果医生拒方，系统将自动退款</div>
        </div>

        <div class="border_num_type">
            <div class="flex1 mar">
                <div>订单编号</div>
                <div class="orther_color">1324654132123132132</div>
            </div>

            <div class="flex1 ">
                <div>订单类型</div>
                <div class="orther_color">视频问诊诊疗费</div>
            </div>


        </div>

        <div class="pay_type_text">支付方式</div>
        <div class="flex1  wechat_pay_box" @click="changeStatus">
            <div class="flex2">
                <img src="@/images/weChatPay.png" class="wechat_img" >
                <div>微信支付</div>

            </div>
            <img :src="isSelect?selectImg:unSelectImg" class="select_img">
        </div>
        <div class="now_pay" @click="payMoney">立即支付</div>
    </div>
</template>
<script>
import selectImg from "@/images/select.png";
import unSelectImg from "@/images/unSelectImg.png";
import {Toast} from "vant"
export default {
    data:function(){
        return {
            isSelect:true,
            selectImg,
            unSelectImg,
            min:15,
            second:59
        }
    },
    methods:{
        changeStatus(){
            this.isSelect = !this.isSelect
        },
        payMoney(){
            if(!this.isSelect){
                Toast("请选择支付方式")
                return 
            }
        }
    },
    mounted(){
        // document.title = this.$route.meta.title
        let that = this
        let timer = setInterval(function(){
            if(that.min>0){
                if(that.second>0){
                    that.second--
                }else{
                    that.min--
                    that.second=59
                }
            }else if(that.min==0){
                if(that.second>0){
                    that.second--
                }else{
                    clearInterval(timer)
                }
            }
        },1000)
    }
}
</script>
<style lang="scss" scoped   src="../scss/mobile_payment.scss">

</style>